module.exports = __webpack_public_path__ + "img/qrcode1_1.aefd9559.jpg";